import { dateRangeMonths, getDateRange } from "@app/lib/date-range";
import { getPerspectiveId } from "@app/lib/perspective";
import DashboardPage, {
  dashboardQuery,
} from "@app/pages/dashboard/dashboard-page";
import type { dashboardPage_Query } from "@app/queries/dashboardPage_Query.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

export const Route = createFileRoute("/_authed/dashboard")({
  loader: () =>
    loadQuery<dashboardPage_Query>(
      environment,
      dashboardQuery,
      {
        perspectiveId: getPerspectiveId() ?? undefined,
        months: dateRangeMonths(getDateRange()),
      },
      { fetchPolicy: "store-or-network" }
    ),
  head: () => pageHead("Dashboard"),
  component: DashboardRoute,
});

function DashboardRoute() {
  const queryRef = Route.useLoaderData();

  return (
    <ErrorBoundary
      fallback={<div className="p-6 text-red-500">Error loading dashboard</div>}
    >
      <Suspense
        fallback={<div className="p-6 text-gray-500">Computing KPIs...</div>}
      >
        <DashboardPage queryRef={queryRef} />
      </Suspense>
    </ErrorBoundary>
  );
}
